import styled from '@emotion/styled';

/**
 * FutureVisionPage — Page 5 of the Kuutio print report.
 *
 * "2. TOIVOTTU TULEVAISUUS" — left body text + right illustration.
 * All positions from IDML Spread_ud7.xml via idml-to-css.mjs.
 *
 * Elements:
 *   u4df: Title at left:42.5pt top:29.7pt (Otsikot style)
 *   u260: Body text at left:41.1pt top:79.4pt w:287.7pt h:428pt (Leipis)
 *   u4600: Image at left:337pt top:98.3pt w:479.6pt h:445.1pt (hyvanelamankipina.png)
 */
export default function FutureVisionPage({
  instanceNumber = '3',
  topic = 'Kansainvälisten opiskelijoiden työllistyminen Suomeen',
}) {
  return (
    <Page className="page future-vision-page">
      <TitleFrame>
        <Title>2. TOIVOTTU TULEVAISUUS</Title>
      </TitleFrame>
      <YellowRule />

      <BodyFrame>
        <Body>
          Tulevaisuus on tällä hetkellä olemassa vain mieli­kuvituksessamme.
          Kuvittelu on jokaisen sisäsyntyinen ominaisuus, joka voi avata ovia
          lukemattomiin mahdollisiin tulevaisuuksiin. Se mitä kuvittelemme,
          vaikuttaa tunteisiimme ja toimintaamme nykyhetkessä ja täten
          tulevaisuuden suuntaan.
        </Body>
        <Body>
          Kuvittelimme toivottavia tulevaisuuksia seuraavien tehtävien avulla:
        </Body>
        <Body>
          <strong>
            1. Kuvittele 24 tuntia tulevaisuuden Suomessa,
            johon kansainvälisten opiskelijoiden on hyvä tulla
            ja rakentaa elämäänsä opintojen jälkeen. Mikä
            Suomessa on mahdollista kun yhteiskunta on aidosti
            oppinut arvostamaan kansainvälisiä osaajia?
          </strong>
        </Body>
        <Body>
          Kuvittele tuntemasi kansainvälinen opiskelija tai
          osaaja tähän parhaaseen mahdolliseen tulevaisuuteen
          ja kirjoita hänen vuorokaudestaan siellä
          mahdollisimman yksityiskohtaisesti.{'\n'}
          Miltä elämä tässä yhteiskunnassa näyttää ja tuntuu?
        </Body>
        <Body>
          Tehtävä tehtiin itsenäisesti omaan työkirjaan.
        </Body>
        <Body>
          <strong>
            2. Minkä yhden asian toisit tulevaisuudesta tähän
            hetkeen eli mikä on se yksi tärkein muutos, jonka
            toivot tapahtuvan?
          </strong>
        </Body>
        <Body>
          Osallistujat kirjoittivat yhden toivomansa muutoksen
          nimettömänä lapulle. Tekoäly koosti lapuista
          kollektiivisen tulevaisuustarinan eli kuvauksen
          tulevaisuudesta, jossa nuo muutokset ovat
          tapahtuneet. Löydät tarinan seuraavalta sivulta.
        </Body>
      </BodyFrame>

      {/* Right illustration */}
      <ImageFrame>
        <img
          src="/assets/report/hyvanelamankipina.png"
          alt="Toivottu tulevaisuus"
        />
      </ImageFrame>

      <PageFooter>
        <FooterLeft><strong>Kuutio #{instanceNumber}:</strong> {topic}</FooterLeft>
        <FooterRight>5</FooterRight>
      </PageFooter>
    </Page>
  );
}

const Page = styled.div`
  width: 297mm;
  min-height: 210mm;
  background: #fff;
  color: #000;
  position: relative;
  font-family: 'Rational', sans-serif;
  box-sizing: border-box;
  overflow: hidden;

  @media print {
    break-after: page;
  }
`;

const TitleFrame = styled.div`
  position: absolute;
  left: 42.5pt;
  top: 29.7pt;
  width: 354.8pt;
`;

const Title = styled.h1`
  font-size: 22pt;
  font-weight: 700;
  font-style: italic;
  text-transform: uppercase;
  margin: 0;
`;

const YellowRule = styled.div`
  position: absolute;
  left: 42.5pt;
  top: 58pt;
  width: calc(297mm - 42.5pt - 28.3pt);
  height: 3pt;
  background: #FBE300;
`;

/* Body text: Leipis — Book 11pt/13pt */
const BodyFrame = styled.div`
  position: absolute;
  left: 41.1pt;
  top: 79.4pt;
  width: 287.7pt;
`;

const Body = styled.p`
  font-size: 11pt;
  font-weight: 400;
  line-height: 13pt;
  margin: 0 0 10pt 0;
  white-space: pre-line;
`;

/* Right illustration: 479.6 x 445.1pt */
const ImageFrame = styled.div`
  position: absolute;
  left: 337.0pt;
  top: 98.3pt;
  width: 479.6pt;
  height: 445.1pt;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const PageFooter = styled.div`
  position: absolute;
  bottom: 14pt;
  left: 42.5pt;
  right: 28.3pt;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 0.5pt solid rgba(0, 0, 0, 0.3);
  padding-top: 6pt;
`;

const FooterLeft = styled.span`
  font-size: 8pt;
  font-style: italic;
  font-weight: 400;
`;

const FooterRight = styled.span`
  font-size: 10pt;
  font-weight: 400;
`;
